<section id="columnImportExport" >  
    <div class="row">
        <div class="col">
            <h4><b>Save Data / Load Data</b></h4>
            <div class="row">
                <button [ngClass]="{'grayed-out': importButtonGrayedOutBasedOnMatSteps()}" class="btn btn-primary no-arrow" (click)="exportToJson()">
                    Save
                </button>
                <button [ngClass]="{'grayed-out': exportButtonGrayedOutBasedOnMatSteps()}" mat-raised-button class="btn btn-primary no-arrow" (click)="openFileDialog()">
                    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
                    <span *ngIf="!isLoading">Open</span>
                </button>
                <input *ngIf="!exportButtonGrayedOutBasedOnMatSteps()" type="file" #fileInput hidden (change)="importFromJson(fileInput.files)" (cancel)="isLoading=false">
            </div>
        </div>
    </div>
</section> 